// Аутентификация – проверка подлинности пользователя (email / пароль → токен).

/** Ключ в localStorage (имя историческое, менять значение нельзя — вылогинит всех). */
const AUTH_STORAGE_KEY = 'jwt_token'

import axios from "axios";

/**
 * Декодирует payload из токена (часть до первой точки, base64 JSON).
 * @param {string|null|undefined} token
 * @returns {object|null}
 */
function parseTokenPayload(token) {
	if (token == null || typeof token !== 'string') {
		return null
	}
	const dot = token.indexOf('.')
	if (dot <= 0) {
		return null
	}
	try {
		const json = atob(token.slice(0, dot))
		const data = JSON.parse(json)
		return data !== null && typeof data === 'object' ? data : null
	} catch {
		return null
	}
}

/**
 * Нормализует ответ auth.php: JSON { token } / { error } или старая строка токена / AUTH_ERROR.
 * @param {*} data — response.data от axios
 * @returns {{ token?: string, isAuthError: boolean }}
 */
function normalizeAuthResponse(data) {
	if (data == null) {
		return { isAuthError: true }
	}
	if (typeof data === 'string') {
		if (data === 'AUTH_ERROR') {
			return { isAuthError: true }
		}
		return { token: data, isAuthError: false }
	}
	if (typeof data === 'object') {
		if (data.error === 'AUTH_ERROR') {
			return { isAuthError: true }
		}
		if (data.token != null && typeof data.token === 'string') {
			return { token: data.token, isAuthError: false }
		}
	}
	return { isAuthError: true }
}

export default {
	namespaced: true,

	state: {
		token: localStorage.getItem(AUTH_STORAGE_KEY),
		authError: null,
	},

	getters: {
		token(state) {
			return state.token
		},
		authError(state) {
			return state.authError
		},
		isAuth(state) {
			return !!state.token
		},
		userId(state) {
			const p = parseTokenPayload(state.token)
			return p != null && p.id != null ? p.id : null
		},
		user(state) {
			return parseTokenPayload(state.token)
		},
	},

	mutations: {
		setToken(state, token) {
			if (token === 'AUTH_ERROR') {
				state.authError = 'ERROR'
				state.token = null
				localStorage.removeItem(AUTH_STORAGE_KEY)
			} else {
				state.authError = null
				state.token = token
				localStorage.setItem(AUTH_STORAGE_KEY, token)
			}
		},
		setAuthError(state, code) {
			state.authError = code
		},
		clearAuthError(state) {
			state.authError = null
		},
		logout(state) {
			state.token = null
			state.authError = null
			localStorage.removeItem(AUTH_STORAGE_KEY)
		},
	},

	actions: {
		/**
		 * @returns {Promise<boolean>} true при успешном входе
		 */
		async loginEmail({ commit }, payload) {
			commit('clearAuthError')
			const authUrl = process.env.VUE_APP_ADMIN_URL + '/api/auth.php'
			try {
				const { data } = await axios.post(authUrl, payload)
				const { token, isAuthError } = normalizeAuthResponse(data)
				if (isAuthError || !token) {
					commit('setToken', 'AUTH_ERROR')
					return false
				}
				commit('setToken', token)
				return true
			} catch (e) {
				console.error('loginEmail:', e)
				commit('setAuthError', 'NETWORK')
				return false
			}
		},
	},
}
